import React from 'react';
export function SiteBannerIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6a1 1 0 11-2 0 1 1 0 012 0zM20 10H4V8h16v2zM5 13a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1z"
  }));
}